import { useState, useEffect } from 'react';

/**
 * Hook pre typewriter efekt - postupne zobrazuje text znak po znaku dopredu aj dozadu (cyklicky)
 */
export const useTypewriter = (text, speed = 50, startDelay = 0, pauseBeforeDelete = 2000, deleteSpeed = 30) => {
  const [displayedText, setDisplayedText] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    if (!text) return;

    let timeoutId;
    let currentIndex = 0;
    let isDeletingMode = false;

    const startTyping = () => {
      setIsTyping(true);
      setIsDeleting(false);
      setDisplayedText('');
      currentIndex = 0;
      isDeletingMode = false;

      const type = () => {
        if (!isDeletingMode) {
          // Písanie dopredu
          if (currentIndex < text.length) {
            setDisplayedText(text.substring(0, currentIndex + 1));
            currentIndex++;
            timeoutId = setTimeout(type, speed);
          } else {
            // Po dokončení písania počkáme pred mazaním
            setIsTyping(false);
            timeoutId = setTimeout(() => {
              isDeletingMode = true;
              setIsDeleting(true);
              currentIndex = text.length;
              type(); // Začneme mazať
            }, pauseBeforeDelete);
          }
        } else {
          // Mazanie dozadu
          if (currentIndex > 0) {
            setDisplayedText(text.substring(0, currentIndex - 1));
            currentIndex--;
            timeoutId = setTimeout(type, deleteSpeed);
          } else {
            // Po vymazaní začneme znova písať
            setIsDeleting(false);
            isDeletingMode = false;
            currentIndex = 0;
            timeoutId = setTimeout(type, speed);
          }
        }
      };

      type();
    };

    if (startDelay > 0) {
      timeoutId = setTimeout(startTyping, startDelay);
    } else {
      startTyping();
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [text, speed, startDelay, pauseBeforeDelete, deleteSpeed]);

  return { displayedText, isTyping, isDeleting };
};
